import {Query} from '@apollo/client/react/components';
import {Link} from 'gatsby';
import gql from 'graphql-tag.macro';
import PropTypes from 'prop-types';
import React from 'react';
import {FormattedMessage} from 'react-intl';

const TRACK_COURSES = gql`
  query trackCourses($trackId: ID!) {
    track(id: $trackId) {
      id
      slug
      trackstepSet {
        edges {
          node {
            course {
              id
              slug
              name
            }
          }
        }
      }
    }
  }
`;

const NextCourseButton = ({courseSlug, isDegree, trackId}) => {
  return (
    <Query
      query={TRACK_COURSES}
      variables={{trackId: btoa(`TrackType:${trackId}`)}}
    >
      {({loading, error, data}) => {
        if (loading) return null;
        if (loading || error) {
          return null;
        }
        const {track} = data;
        if (!track || !track.trackstepSet || !track.trackstepSet.edges) {
          return null;
        }
        const courses = track.trackstepSet;
        const currentCourseIndex = courses.edges.findIndex(
          ({
            node: {
              course: {slug},
            },
          }) => slug === courseSlug,
        );
        const courseLength = courses.edges.length;

        return (
          <div>
            <Link
              to={`${isDegree ? '/degrees' : ''}/${track.slug}/${
                currentCourseIndex < courseLength - 1
                  ? courses.edges[currentCourseIndex + 1].node.course.slug
                  : courses.edges[0].node.course.slug
              }`}
              className="fw6 white pa3 dib no-underline tc br2 bg-green-light bg-animate hover-bg-green"
            >
              {currentCourseIndex < courseLength - 1 ? (
                <p>
                  <FormattedMessage id="next_course" />:{' '}
                  {courses.edges[currentCourseIndex + 1].node.course.name}
                </p>
              ) : (
                <FormattedMessage id="review_track_button" />
              )}
            </Link>
          </div>
        );
      }}
    </Query>
  );
};

NextCourseButton.propTypes = {
  courseSlug: PropTypes.string.isRequired,
  isDegree: PropTypes.bool.isRequired,
  trackId: PropTypes.number.isRequired,
};

export default NextCourseButton;
